module.exports = __webpack_public_path__ + "static/media/info-icon.067cc460.svg";